/**
 * API Configuration
 * 
 * This file centralizes API endpoint configuration and provides
 * environment-specific settings.
 */

// Base API URL - handles both development and production
// In production (when VITE_API_URL is empty), uses same-origin (relative URLs)
// In development, defaults to localhost:3000
export const API_URL = import.meta.env.VITE_API_URL || 
  (import.meta.env.PROD ? '' : 'http://localhost:3000');

// API Base Path
export const API_BASE = `${API_URL}/api/v1`;

// Feature flags
export const FEATURES = {
  VIDEO_CALLS: import.meta.env.VITE_ENABLE_VIDEO_CALLS === 'true',
  PRESCRIPTIONS: import.meta.env.VITE_ENABLE_PRESCRIPTIONS === 'true',
  REALTIME: import.meta.env.VITE_ENABLE_REALTIME === 'true',
};

/**
 * Creates headers for API requests
 * @param {string} token - Authentication token (optional)
 * @returns {Object} Headers object
 * @deprecated Use apiClient.js instead
 */
export const createHeaders = (token = null) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  return headers;
};
